<mat-form-field class="do3-input ">
  <input matInput [placeholder]="label" [type]="type" [value]="value">
</mat-form-field>
